import { atom } from 'jotai';

import { PageProps } from './types';

export const nextPagePropsAtom = atom<PageProps | null>(null);
